function isValidEmail (email) {
  var regex = /^([a-zA-Z0-9_.'+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

export default isValidEmail;
//# sourceMappingURL=is-valid-email.esm.js.map
